import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getAttestationCycleFormConfig = () => {
  return {
    requireAttestationFromEveryone: {
      fieldId: 'requireAttestationFromEveryone',
      formLabel: t('policy.fields.AttestationTarget'),
      allowAsConditionSource: true,
    },
    attestationGroups: {
      fieldId: 'attestationGroups',
      formLabel: t('policy.fields.AttestationGroups'),
      allowTargetConditions: true,
    },
    requireReattestation: {
      fieldId: 'requireReattestation',
      formLabel: t('policy.fields.AttestationReissue'),
      allowAsConditionSource: true,
    },
    attestationTimeLimit: {
      fieldId: 'attestationTimeLimit',
      formLabel: t('policy.fields.AttestationTimeLimit'),
      allowAsConditionSource: true,
    },
    attestationPromptText: {
      fieldId: 'attestationPromptText',
      formLabel: t('policy.fields.AttestationPromptText'),
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
